<template>
  <span
    class="progress-indicator" :class="{'progress-indicator--hidden': isWelcome}"
    :style="{ '--width': progress + '%' }"
  ></span>
</template>
<script>
export default {
  name: 'ProgressIndicator',
  props: {
    step: {
      type: Number,
      required: true,
    },
    stepsTotal: {
      type: Number,
      required: true,
    },
    isWelcome: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    progress() {
      return (this.step / this.stepsTotal) * 100;
    },
  },
};
</script>
<style scoped lang="scss">
.progress-indicator {
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
  height: rem(5px);
  display: block;
  transition: $t-opacity;

  &::after {
    content: "";
    display: block;
    background-color: $purpleDim;
    transition: $t-width;
    height: rem(5px);
    position: absolute;
    left: 0;
    top: 0;
    width: var(--width);
  }

  &--hidden {
    opacity: 0;
  }
}
</style>
